import React from 'react';
import {
  replaceLineBreaks,
  superscriptSpecialChars
} from '../utils/stringUtils';

export function SmartText({
  children,
  classesOverride = ''
}: {
  children: React.ReactNode;
  classesOverride?: string;
}) {
  // Apply replaceLineBreaks first, then superscriptSpecialChars
  return (
    <>
      {superscriptSpecialChars(
        replaceLineBreaks(children as string),
        classesOverride
      )}
    </>
  );
}
